window.servicesVersionPhpCellStyle = function(value, row) {
    if (!value) {
        return false;
    }
    return {
        css: {
            "background-color": row.php_color
        }
    };
};
